import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const AdPlaceholder = ({ size = 'medium', position = 'sidebar' }) => {
  const sizeClasses = {
    small: 'h-32',
    medium: 'h-64',
    large: 'h-96',
    square: 'h-64 w-64',
    banner: 'h-24',
    leaderboard: 'h-32',
  };

  const widthClasses = {
    sidebar: 'w-full',
    inline: 'w-full max-w-4xl mx-auto',
  };

  return (
    <Card className={`${sizeClasses[size]} ${widthClasses[position]} border-dashed border-2 border-muted-foreground/20 bg-muted/10`}>
      <CardContent className="h-full flex flex-col items-center justify-center p-6">
        <Badge variant="outline" className="mb-2">
          Advertisement
        </Badge>
        <p className="text-xs text-muted-foreground text-center">
          {size === 'leaderboard' && '728x90'}
          {size === 'banner' && '468x60'}
          {size === 'medium' && '300x250'}
          {size === 'large' && '300x600'}
          {size === 'square' && '250x250'}
          {size === 'small' && '300x100'}
        </p>
      </CardContent>
    </Card>
  );
};
